// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___3DOCD","aligned":"styles__aligned___2H7Xo","linkButton":"styles__linkButton___1tAAJ","lastLine":"styles__lastLine___3_1G_"};